import { useSearchParams } from 'react-router-dom';
import css from './service-card.module.scss';
import classNames from 'classnames';
import Description from 'src/components/description-block/description';
import Complaint from 'src/pages/complaint/complaint';
import { ComplaintEntityType } from 'src/constants/complaint-entity-type';
import { CardProps } from 'src/types';
import { ReactComponent as ExternalLinkIcon } from 'src/assets/external_link.svg';

export default function ServiceCard({ onClick, service, className }: Readonly<CardProps>) {
  const [searchParams, setSearchParams] = useSearchParams();
  const showTitleInHeader = !service.imgUrl;

  function handleServiceClick() {
    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.set('slug', service.slug);
    if (nextSearchParams.toString() !== searchParams.toString()) setSearchParams(nextSearchParams);
    onClick?.({ title: service.title, url: service.url, slug: service.slug });
  }

  const wrapper = (
    complaint: JSX.Element,
    onMouseEnter: React.MouseEventHandler<HTMLDivElement> | undefined,
    onMouseLeave: React.MouseEventHandler<HTMLDivElement> | undefined
  ) => (
    <div
      id={service.slug}
      className={classNames(css.card, css[className])}
      onClick={handleServiceClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      aria-hidden>
      {complaint}
      <div className={css.header}>
        {showTitleInHeader && <div className={css.title}>{service.title}</div>}
        {!showTitleInHeader && <img src={service.imgUrl} alt={service.title} />}
      </div>
      <div className={css.content}>
        {!showTitleInHeader && (
          <div className={css.title}>
            <span>{service.title}</span> <ExternalLinkIcon />
          </div>
        )}
        <Description description={service.description} />
      </div>
    </div>
  );

  return (
    <Complaint
      key={service.id}
      entityId={service.id}
      entityType={ComplaintEntityType.SERVICE}
      targetTitle={service.title}
      wrapper={wrapper}
    />
  );
}
